import {
  z_index_default
} from "./chunk-7OKLMD4V.mjs";
import {
  breakpoints_default
} from "./chunk-DDAHWWWN.mjs";
import {
  colors_default
} from "./chunk-C7H5GWRZ.mjs";
import {
  radius_default
} from "./chunk-4REDROSM.mjs";
import {
  shadows_default
} from "./chunk-DJNGX4VH.mjs";
import {
  transition_default
} from "./chunk-AU77DZXY.mjs";
import {
  blur_default
} from "./chunk-OLDNEXT6.mjs";
import {
  borders_default
} from "./chunk-ZV5E32CG.mjs";
import {
  typography_default
} from "./chunk-HOOF7HHD.mjs";
import {
  sizes_default
} from "./chunk-X4JBRTE2.mjs";
import {
  spacing
} from "./chunk-G3IFUAY5.mjs";

// src/foundations/index.ts
var foundations = {
  breakpoints: breakpoints_default,
  zIndices: z_index_default,
  radii: radius_default,
  blur: blur_default,
  colors: colors_default,
  ...typography_default,
  sizes: sizes_default,
  shadows: shadows_default,
  space: spacing,
  borders: borders_default,
  transition: transition_default
};

export {
  foundations
};
